import { render } from "./ContactST.vue?vue&type=template&id=60ae1157"
import script from "./ContactST.vue?vue&type=script&lang=js"
export * from "./ContactST.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\user\\Documents\\Progetti\\IFT-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__